/**
 * Toggles the visibility of the video transcript section
 * @returns {boolean} - Returns true if toggle was successful, false otherwise
 */
function toggleVideoTranscript() {
  // Element references
  const content = document.getElementById('video-transcript');
  const button = document.querySelector('.article__transcript-toggle');

  // Early return if elements don't exist
  if (!content || !button) {
    return false;
  }

  // Toggle collapsed state
  const isCurrentlyCollapsed = content.classList.contains('collapsed');
  content.classList.toggle('collapsed');

  // Update button text
  button.textContent = isCurrentlyCollapsed ? 'Read Less' : 'Read More';

  // Update ARIA attribute for accessibility
  button.setAttribute('aria-expanded', isCurrentlyCollapsed ? 'true' : 'false');

  return true;
}

// Toggle Parent Class Function
function toggleParentClass(event) {
  const target = event.target;
  const parent = target.parentElement;
  parent.classList.toggle('active');
}

// Hide Empty Elements - Removes empty paragraphs and spans from view
document.querySelectorAll('p').forEach((p) => {
  const span = p.querySelector('span');
  if (span && span.innerHTML.trim() === '') {
    p.style.display = 'none';
  }
});

document.querySelectorAll('.article-template span').forEach((span) => {
  if (!span.textContent.trim() || span.innerHTML.replace(/&nbsp;/g, '').trim() === '') {
    span.style.display = 'none';
  }
});

// Table of Contents Generator - Creates TOC from h2 headings
function createTableOfContents() {
  const tableContainer = document.querySelector('.article__table');
  const contentContainer = document.querySelector('.article__content');
  if (!tableContainer || !contentContainer) {
    return;
  }
  const headings = contentContainer.querySelectorAll('h2');
  if (headings.length === 0) {
    return;
  }

  // Create unique IDs for headings if they don't exist
  headings.forEach((heading, index) => {
    if (!heading.id) {
      heading.id = 'toc-section-' + index;
    }
  });

  // Generate TOC list items from headings
  const tocListHTML = Array.from(headings).map(heading => `
    <li class="article__table-item">
      <a href="#${heading.id}" class="article__table-link" data-target="${heading.id}">
        ${heading.textContent}
      </a>
    </li>
  `).join('');

  // Create original TOC HTML structure (without toggle button)
  const createOriginalTocHTML = () => `
    <div class="article__table-content">
      <h3 class="article__table-title">In This Article</h3>
      <ul class="article__table-list">
        ${tocListHTML}
      </ul>
    </div>
  `;

  // Create sticky TOC HTML structure (with toggle button)
  const createStickyTocHTML = () => `
    <button class="toc-toggle">In This Article</button>
    <div class="article__table-content collapsed">
      <h3 class="article__table-title">In This Article</h3>
      <ul class="article__table-list">
        ${tocListHTML}
      </ul>
    </div>
  `;

  // Insert original TOC (always visible, no toggle)
  tableContainer.innerHTML = createOriginalTocHTML();
  
  // Create and insert sticky TOC version for mobile/tablet
  const stickyToc = document.createElement('div');
  stickyToc.className = 'article__table article__table-sticky-version collapsed';
  stickyToc.style.display = 'none';
  stickyToc.innerHTML = createStickyTocHTML();
  tableContainer.parentNode.insertBefore(stickyToc, tableContainer.nextSibling);

  // TOC toggle and link click handlers
  document.addEventListener('click', function(e) {
    // Handle TOC toggle button clicks (only for sticky version)
    if (e.target.classList.contains('toc-toggle')) {
      const tocContent = e.target.nextElementSibling;
      const tocContainer = e.target.closest('.article__table');
      if (tocContent) {
        tocContent.classList.toggle('collapsed');
        // Toggle collapsed class on container
        if (tocContainer) {
          tocContainer.classList.toggle('collapsed');
        }
      }
    }
    
    // Handle TOC link clicks
    if (e.target.classList.contains('article__table-link')) {
      e.preventDefault();
      const targetId = e.target.getAttribute('data-target');
      scrollToHeading(targetId);
      
      // Close TOC on mobile/tablet after clicking a link (only for sticky version)
      if (window.innerWidth <= 1024) {
        const tocContainer = e.target.closest('.article__table');
        // Only collapse if it's the sticky TOC
        if (tocContainer && tocContainer.classList.contains('article__table-sticky-version')) {
          const tocContent = tocContainer.querySelector('.article__table-content');
          if (tocContent) {
            tocContent.classList.add('collapsed');
            tocContainer.classList.add('collapsed');
          }
        }
      }
    }
  });

  initScrollTracking(headings);
}

// Smooth scroll to heading with offset
function scrollToHeading(headingId) {
  const element = document.getElementById(headingId);
  if (element) {
    // Desktop: 80px offset, Mobile/Tablet: 120px offset
    const headerOffset = window.innerWidth <= 1024 ? 120 : 80;
    const elementPosition = element.offsetTop - headerOffset;
    window.scrollTo({
      top: Math.max(0, elementPosition),
      behavior: 'smooth'
    });
  }
}

// Track scroll position and highlight active TOC item
function initScrollTracking(headings) {
  function updateActiveLink() {
    const scrollOffset = 120;
    const scrollPos = window.pageYOffset + scrollOffset;
    let currentId = '';

    // Find the current heading based on scroll position
    headings.forEach(heading => {
      if (heading.offsetTop <= scrollPos) {
        currentId = heading.id;
      }
    });

    // Update active class on TOC items
    document.querySelectorAll('.article__table-item').forEach(item => {
      const link = item.querySelector('.article__table-link');
      const isActive = link.getAttribute('href') === '#' + currentId;
      item.classList.toggle('active', isActive);
    });
  }

  // Throttled scroll listener for performance
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateActiveLink();
        ticking = false;
      });
      ticking = true;
    }
  });
}

// Mobile/Tablet Sticky TOC - Shows/hides sticky TOC based on scroll position
function initMobileStickyTOC() {
  if (window.innerWidth > 1024) return;
  
  const tocOriginal = document.querySelector('.article__table:not(.article__table-sticky-version)');
  const tocSticky = document.querySelector('.article__table-sticky-version');
  const articleContent = document.querySelector('.article__content');
  
  if (!tocOriginal || !tocSticky || !articleContent) return;
  
  let lastScrollTop = 0;
  
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const tocOriginalRect = tocOriginal.getBoundingClientRect();
    const articleRect = articleContent.getBoundingClientRect();
    
    // Show sticky when original TOC is out of view AND article content is still visible
    const shouldShow = tocOriginalRect.bottom < 0 && articleRect.bottom > 200;
    tocSticky.style.display = shouldShow ? 'block' : 'none';
    
    // Change menu position based on scroll direction (only when visible)
    if (shouldShow) {
      if (scrollTop > lastScrollTop) {
        // Scrolling DOWN → stick to top (top: 0)
        tocSticky.classList.add('menu-at-top');
      } else {
        // Scrolling UP → stick below header (top: 65px)
        tocSticky.classList.remove('menu-at-top');
      }
    }
    
    lastScrollTop = scrollTop;
  }
  
  // Throttled scroll listener for performance
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  handleScroll();
}

// Copy Link Functionality - Show tooltip when link is copied
function showTooltip(button, message) {
  const tooltip = document.createElement('div');
  tooltip.className = 'copy-tooltip';
  tooltip.textContent = message;
  button.style.position = 'relative';
  button.appendChild(tooltip);
  const buttonWidth = button.offsetWidth;
  const tooltipWidth = tooltip.offsetWidth;
  tooltip.style.left = `${(buttonWidth - tooltipWidth) / 2}px`;
  tooltip.style.bottom = `${button.offsetHeight + 10}px`;
  setTimeout(() => tooltip.classList.add('copy-tooltip--show'), 10);
  setTimeout(() => {
    tooltip.remove();
  }, 3000);
}

// Initialize all functionality on page load
document.addEventListener('DOMContentLoaded', function () {
  // Initialize Table of Contents
  createTableOfContents();
  initMobileStickyTOC();

  // Initialize Comment Form Validation
  const authorField = document.getElementById('CommentForm-author');
  const emailField = document.getElementById('CommentForm-email');
  const bodyField = document.getElementById('CommentForm-body');
  const submitButton = document.querySelector('.comment-submit');

  if (authorField && emailField && bodyField && submitButton) {
    // Disable submit button initially
    submitButton.style.opacity = '0.5';
    submitButton.style.pointerEvents = 'none';

    // Check if all required fields are filled
    function checkFields() {
      if (authorField.value.trim() !== '' && emailField.value.trim() !== '' && bodyField.value.trim() !== '') {
        submitButton.style.opacity = '1';
        submitButton.style.pointerEvents = 'auto';
      } else {
        submitButton.style.opacity = '0.5';
        submitButton.style.pointerEvents = 'none';
      }
    }

    // Listen for input changes on all fields
    authorField.addEventListener('input', checkFields);
    emailField.addEventListener('input', checkFields);
    bodyField.addEventListener('input', checkFields);
  }

  // Initialize Copy Link Buttons
  document.querySelectorAll('.share-button--copy').forEach((button) => {
    button.addEventListener('click', async function (e) {
      e.preventDefault();
      try {
        await navigator.clipboard.writeText(window.location.href);
        showTooltip(this, 'Link copied!');
      } catch (error) {
        const textArea = document.createElement('textarea');
        textArea.value = window.location.href;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        showTooltip(this, 'Link copied!');
      }
    });
  });
});

// Make functions globally available
window.toggleVideoTranscript = toggleVideoTranscript;
window.toggleParentClass = toggleParentClass;